/**
 * sl-sbpf.1: Frontend facade for the canonical AppBase CSS contract.
 *
 * The canonical definition lives in @streamlain/view-config (it is shared
 * with the SSR custom-app-viewer bundle and backend materialization). Local
 * const bindings keep the established frontend-core import path visible to
 * webpack's strict export analysis.
 */
import type {
  AppBaseComponentId,
  AppBaseCssVar,
  AppBaseFlagAttr,
  AppBaseShellRoleId,
  AppBaseStateValue,
} from '@streamlain/view-config';
import * as ViewConfig from '@streamlain/view-config';

export const APP_BASE_COMPONENT_ATTR = ViewConfig.APP_BASE_COMPONENT_ATTR;
export const APP_BASE_COMPONENT_ID_VALUES =
  ViewConfig.APP_BASE_COMPONENT_ID_VALUES;
export const APP_BASE_COMPONENT_IDS = ViewConfig.APP_BASE_COMPONENT_IDS;
export const APP_BASE_CSS_VARS = ViewConfig.APP_BASE_CSS_VARS;
export const APP_BASE_FIELD_ATTR = ViewConfig.APP_BASE_FIELD_ATTR;
export const APP_BASE_FIELD_TYPE_ATTR = ViewConfig.APP_BASE_FIELD_TYPE_ATTR;
export const APP_BASE_FLAG_ATTRS = ViewConfig.APP_BASE_FLAG_ATTRS;
export const APP_BASE_LINT_FORBIDDEN_PROPERTIES =
  ViewConfig.APP_BASE_LINT_FORBIDDEN_PROPERTIES;
export const APP_BASE_LINT_FORBIDDEN_SELECTORS =
  ViewConfig.APP_BASE_LINT_FORBIDDEN_SELECTORS;
export const APP_BASE_MOTION_CLASS_PREFIX =
  ViewConfig.APP_BASE_MOTION_CLASS_PREFIX;
export const APP_BASE_MOTION_INDEX_CSS_VAR =
  ViewConfig.APP_BASE_MOTION_INDEX_CSS_VAR;
export const APP_BASE_ROLE_ATTR = ViewConfig.APP_BASE_ROLE_ATTR;
export const APP_BASE_ROOT_ATTRS = ViewConfig.APP_BASE_ROOT_ATTRS;
export const APP_BASE_SCOPE_CLASS = ViewConfig.APP_BASE_SCOPE_CLASS;
export const APP_BASE_SHELL_ROLE_IDS = ViewConfig.APP_BASE_SHELL_ROLE_IDS;
export const APP_BASE_STATE_ATTR = ViewConfig.APP_BASE_STATE_ATTR;
export const APP_BASE_STATE_VALUES = ViewConfig.APP_BASE_STATE_VALUES;

export type {
  AppBaseComponentId,
  AppBaseCssVar,
  AppBaseFlagAttr,
  AppBaseShellRoleId,
  AppBaseStateValue,
};
